// extracted by mini-css-extract-plugin
export var blue = "_2b-g";
export var brand = "_2b-c";
export var darkGrey = "_2b-f";
export var disabled = "_2b-6";
export var disabledSubtle = "_2b-7";
export var error = "_2b-8";
export var green = "_2b-h";
export var grey = "_2b-e";
export var icon = "_2b-0";
export var inherit = "_2b-b";
export var lightGrey = "_2b-d";
export var orange = "_2b-j";
export var pink = "_2b-l";
export var primary = "_2b-1";
export var purple = "_2b-m";
export var quaternary = "_2b-4";
export var quinary = "_2b-5";
export var red = "_2b-k";
export var secondary = "_2b-2";
export var success = "_2b-a";
export var tertiary = "_2b-3";
export var warning = "_2b-9";
export var white = "_2b-n";
export var yellow = "_2b-i";